<template>
  <div class="container-fluid component">
    <div class="pt-5 mb-4">
      <v-alert
    class="py-4"
    v-if="!show_alert"
      v-model="verification_alert"
      type="error"
    >
    A FIN DE PROTEGER NOS CLIENTS, ET DE NOUS CONFORMER A LA REGLEMENTATION EN VIGUEUR, LA VERIFICATION D'IDENTITE EST OBLIGATOIRE VEUILLEZ VERIFIER VOTRE 
    IDENTITE POUR UTILISER LA PLATEFORME HIROPAY
    </v-alert>
    </div>
    <vs-button v-if="account_status!=='verified'" size="xl" block class="py-1" @click='verify_identity'>
              Verifier mon identité
      </vs-button>

      <v-alert
    class="py-4 mt-4"
    v-if="!show_alert"
      v-model="verification_alert"
      type="success"
    >
    EN ATTANDANT LA VERIFICAION D'IDENTITE VOUS POUVEZ JUSTE VENDRE BNB ET USDT <v-btn class="mx-2 px-3" color="red" @click="instant_dialog" >essayez le SWAP</v-btn>
    </v-alert>

      <v-navigation-drawer app dark>
      <v-layout column align-center>
        <v-flex class="mt-5 pt-5">
          <v-avatar size="100" color="red">
            <img src="/img/avatar.svg" alt="alt" />
          </v-avatar>
          <p class="white--text subheading mt-3">{{user.firstName}} {{user.lastName}}</p>
        </v-flex>
      </v-layout>

      <v-list class="ml-5 mt-5">
        <v-list-tile v-for="item in items" :key="item.title" @click :to="item.href">
          <v-list-tile-action>
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title class="white--text">{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <div class="pt-4" v-if="show_alert">
      <v-layout row wrap>
      <v-flex xs6>
        <v-layout column align-center>
        <v-flex text-xs-center>
          <v-card
            max-width="200"
            class="commission px-4"
            :hover="true"
            elevation-10
            color="#E6E6E6"
            @click="transfer"
          >
            <v-card-text>
              <img src="/img/money.svg" width="40" alt />
              <span class="subheading commission">commission</span>
              <h1 id="countup"></h1>
            </v-card-text>
          </v-card>
          <Transfer v-if="user.bonus >=500" :total="user.bonus" action_type="bonus" />
        </v-flex>
      </v-layout>
      </v-flex>


      <v-flex xs6>
        <v-layout column align-center>
        <v-flex text-xs-center>
          <v-card
            max-width="200"
            class="commission px-4"
            :hover="true"
            elevation-10
            color="#E6E6E6"
            @click="partner"
          >
            <v-card-text>
              <img src="/img/money.svg" width="40" alt />
              <span class="subheading commission">Partenariat</span>
              <h1 id="partner"></h1>
            </v-card-text>
          </v-card>

          <Transfer v-if="user.partn_cfa > 0" :total="user.partn_cfa" action_type="partner" />
        </v-flex>
      </v-layout>
      </v-flex>
      </v-layout>
    <h4   style="text-align:center;" class="pt-2">Lien parrainage:  <span @click="copy"  v-if="account_status== 'verified'"><input  type="text" id="less" :value="lien" > <v-icon class="copy" color="success">file_copy</v-icon></span>
    <span @click="verify_identity" class="red--text" v-if="account_status!== 'verified'">Veuillez verifier votre compte pour avoir votre lien de parrainage</span> 
    </h4>
    </div>
    <v-layout row wrap class="mx-2 my-4">
      <v-flex xs12 sm6>
        <h1 class="profile">Mon profile</h1>
        <div class="mt-5 px-2">
          <p>
            <span class="unit-input px-2">
              <span class="unit-input__prepend">
                <v-icon>person</v-icon>
              </span>
              <input class="unit-input__input" type="text" v-model="name" disabled />
            </span>
          </p>
          <br />
          <p>
            <span class="unit-input px-2">
              <span class="unit-input__prepend">
                <v-icon>email</v-icon>
              </span>
              <input class="unit-input__input" type="text" v-model="user.email" disabled />
            </span>
          </p>
          <br />
          <p>
            <span class="unit-input px-2">
              <span class="unit-input__prepend">
                <img :src="`/img/${user.country}.png`||''" width="30s" alt />
              </span>
              <input class="unit-input__input" type="text" v-model="user.country" disabled />
            </span>
          </p>
          <br />
          <p>
            <span class="unit-input px-2">
              <span class="unit-input__prepend">
                <v-icon>calendar_today</v-icon>
              </span>
              <input
                class="unit-input__input"
                type="text"
                
                disabled
              />
            </span>
          </p>
          <br />

            <h3 v-if="account_status== 'verified'">Statut du compte : <span class="green">verifié</span> <v-icon class="font-weight-bold" color="success">check</v-icon> </h3>
            <h3 v-if="account_status!== 'verified'">Statut du compte : <span class="red">Non verifié</span> <v-icon class="font-weight-bold" color="error">close</v-icon> </h3>
          
        </div>
      </v-flex>

      <v-flex xs12 sm6>
        
        <div class="referal" >
          <v-flex xs12 text-xs-center>
            
            <h1>Mes filleuils({{referals.length}})</h1>
          </v-flex>
          <div style="max-height:420px; overflow-y:auto; overflow-x: hidden;">
            <div v-for="(item) in referals" :key="item" >
            <p class="referal mt-3">
              <span>
                <v-icon>email</v-icon>
              </span>
              {{item.substring(0, 5)}}xxxxx@...{{item.substring(item.length-4, item.length)}}
            </p>
          </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <div class="container mb-5 auth" v-if="show_alert">
      
      <v-flex xs12 text-xs-center>
        <h1>Sécurité</h1>
      </v-flex>
      <div class="security pt-4 mt-4 px-5">
        <h2>Authentification à deux facteurs (2-FA)</h2>
        <p
          class="subheading pl-4"
        >Pour accroître la sécurité de votre compte veillez activer l'une des options ci-dessous</p>
        <div class="mt-5">
          <div style="text-align:center;">
            <v-icon
              :color="`${check?'blue':''}`"
              size="40"
              style="cursor:pointer;"
              @click="check? desable_2fa_dialog=true :generate()"
            >{{check?"check_circle": "radio_button_unchecked"}}</v-icon>
            <h2 class="pb-3 ml-4 mr-2" style="display:inline-block;">Google 2FA </h2><span style="display:inline-block;" class="pb-3 caption red--text"> (recommandé)</span><v-btn class="ml-2" v-if="!check" @click="generate()" color="success">activer</v-btn><v-btn class="ml-2" v-if="check" color="error" @click="desable_2fa_dialog=true">Desactiver</v-btn><br>


            <v-icon
              :color="`${!check?'blue':''}`"
              size="40"
              style="cursor:pointer;"
              @click="!check? '' :''"
            >{{!check?"check_circle": "radio_button_unchecked"}}</v-icon>
            <h2 class="pb-3 ml-4" style="display:inline-block; vertical-align:middle;">Code PIN</h2>


          </div>
          <div>
            <v-dialog v-model="dialog" max-width="650">
              <v-card>
                <v-card-title class="headline grey lighten-2 pa-3" primary-title>
                  <div style="display:block; text-align:center; margin:auto;"><img src="/img/2fa.svg" width="45" alt=""  > Google 2-FA</div>
                </v-card-title>

                <v-card-text class="px-3 pt-3 mb-4">
                  <p
                    class="subheading"
                  >Suivez ces instructions pour activer le Google 2FA sur votre compte</p>
                  <br />
                  <div class="pl-4">
                    <p>
                      Telechargez et installez
                      <a
                        href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
                        target="_blank"
                      >GOOGLE AUTHENTICATOR</a>
                    </p>
                    <br />
                    <p>Scannez le code QR avec l'application</p>
                    <br />
                    <p>Copiez et gardez soigneusement la clé secrète</p>
                    <br />
                    <p>Entrez ensuite le code généré par l'application</p>
                    <br />

                    <img id="image" class="mr-3" style="display:inline-block" />
                    <input
                      class="code"
                      v-model="code"
                      type="number"
                      onkeypress="if(this.value.length==6) return false;"
                    />
                    <br />
                  </div>
                  <div>
                    <label class="mr-2">Clé secrete:</label>
                    <input
                      v-model="secret"
                      style="display:inline-block; min-width:200px; font-weight:bold;"
                      class="secret"
                      type="text"
                      disabled
                    />
                  </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialog = false">fermer</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

          </div>

          <div>
            <v-dialog v-model="desable_2fa_dialog" max-width="650">
              <v-card>
                <v-card-title class="headline grey lighten-2 pa-3" primary-title>
                  <div style="display:block; text-align:center; margin:auto;">Desactiver Google 2-FA</div>
                </v-card-title>

                <v-card-text class="px-3 pt-1 mb-4">
                  <div style="display:block; max-width:100%; text-align:center">
                      <img src="/img/2fa.svg" width="70"  >
                  </div>
                  <p
                    class="red--text title mb-2"
                    style="display:block; max-width:100%; text-align:center"
                  >Votre compte deviendra vulnérable aux attaques</p>
                  <p
                    class="caption"
                    style="display:block; max-width:100%; text-align:center"
                  >Entrez le code a 6 chiffres pour desactiver Google 2FA</p>
                  <br />
                  <div class="pl-4" style="text-align:center">
                    <input
                      class="code"
                      v-model="desable_code"
                      type="number"
                      onkeypress="if(this.value.length==6) return false;"
                    />
                    <br />
                  </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="desable_2fa_dialog= false">fermer</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
const Transfer = () => import("../components/Transfer")
import firebase from "../fb";
import axios from 'axios'
import db from "../db"
import { CountUp } from "countup.js";
export default {
  components: {
    Transfer,
  },
  data() {
    return {
      drawer: false,
      referals:[],
      show_referal:false,
      desable_2fa_dialog: false,
      verification_alert:true,
      dialog: false,
      code: "",
      desable_code: "",
      qr: false,
      secret: "",
      pass:process.env.VUE_APP_SECRET,
      cle: "",
      headers: [
        { text: "Date", align: "left", sortable: false },
        { text: "Type", align: "left", sortable: false },
        { text: "Montant", sortable: false },
        { text: "Total", sortable: false }
      ],
      rem: [{ text: "Email", align: "left", sortable: false }],
      http: "https://hiropay.com/register/",
      items: [
        { title: "Personal", icon: "person", href: "/dashboard/account" },
        { title: "Dashboard", icon: "dashboard", href: "/dashboard" }
      ]
    };
  },
  computed: {
    lien() {
      return this.http + this.user.id;
    },
    check() {
      return this.user.auth2fa.google;
    },

    show_alert(){
      let data
      if (this.user.verification) {
       data = this.user.verification.verified
      }else{
        data = true
      }
      return data
    },

    name() {
      return this.user.firstName + " " + this.user.lastName;
    },

    ...mapGetters({
      trades: "",
      user: "authfb/user",
    })
  },
  mounted() {
    

    const get_referals = async()=> {
      let user = firebase.auth().currentUser;
      let base_url = this.base_url
      if (location.hostname === "localhost") {
            base_url = 'http://localhost:4000'
        }
      let url  = base_url + "/db_access/get_referals"
      let auth_token = await this.firebase_auth_token()
      let post_data = {
        user_id : user.uid
      }
      axios.post(url,post_data,auth_token).then(result =>{
        let {data} = result
        console.log(data.length);
        this.referals = data
        this.show_referal = true
        console.log(this.show_referal);
      })
    }

    get_referals()
    setTimeout(() => {
      let val = Math.floor(this.user.bonus) ;
      var countUp = new CountUp("countup", val || 0);
      countUp.start();
    }, 700);

    setTimeout(() => {
      let val = Math.floor(this.user.partn_cfa)|| 0;
      var countUp = new CountUp("partner", val || 0);
      countUp.start();
    }, 700);
  },
  watch: {
    code(newValue, oldValue) {
      if (newValue.length == 6) {
        let user =  firebase.auth().currentUser;
        let user_id = user.uid
        let payload={
                  secret:this.secret,
                  user_id,
                  action: 'enable',
                  token: this.code
              }
              this.update_user_auth(payload)
      }
    },
    desable_code(newValue, oldValue) {
      if (newValue.length == 6) {
        let user =  firebase.auth().currentUser;
        let user_id = user.uid
        let secret = this.$store.getters['authfb/user'].auth2fa.secret
        let payload={
                  secret,
                  user_id,
                  action: 'disable',
                  token: this.desable_code
              }
        this.update_user_auth(payload)
    }
  }
  },

  methods: {
     instant_dialog() {
       console.log('hiii');
     this.$root.$emit('activate_instant_dialog')
    },
    
    copy() {
      var copyText = document.getElementById("less");
      copyText.select();
      document.execCommand("copy");
      swal("Lien copié avec success!");
    },

    transfer(){
     let val = Math.floor(this.user.bonus) ;
      var countUp = new CountUp("countup", val || 0);
      countUp.start();
    },
    partner(){
     let val = Math.floor(this.user.partn_cfa)|| 0;
      var countUp = new CountUp("partner", val || 0);
      countUp.start();
    },

    async generate() {

      swal({
        text: "CODE PIN",
        content: {
          element: "input",
          attributes: {
            placeholder: "Enter PIN",
            type: "password",
          },
        },
        button: {
          text: "confirm",
          closeModal: true
        }
      }).then(async value => {
        let bcrypt = require("bcryptjs");
        let hash = this.$store.getters["authfb/pin"];
        bcrypt.compare(value, hash).then(async res => {
          if (res) {
            console.log(res);
            this.dialog = true;
            if (this.secret !== '') {
              return
            }

        const loading = this.$vs.loading()
        let user = firebase.auth().currentUser;
        let auth_token = await this.firebase_auth_token()
        let base_url = this.base_url
        if (location.hostname === "localhost") {
          base_url = 'http://localhost:4000'
        }
          let url = base_url + '/auth_pay/totp-secret'
            axios
              .post(url, {
                email: user.email
              },auth_token)
              .then(response => {
                loading.close();
                let data = response.data;
                this.secret = data.secret;
                console.log(data);
                var a = document.getElementById("image");
                a.setAttribute("src", data.uri);
                this.qr = true;
              });

          } else {
            swal("incorrect PIN!", "", "error", {
              button: "ok"
            });
          }
        });
      });


    },

    async update_user_auth(payload){
        console.log('update auth');
            let baseurl = `${this.base_url}/db_access`
               let auth_token = await this.firebase_auth_token()
            if (location.hostname === "localhost") {
                  baseurl = 'http://localhost:4000/db_access'
                }
            let url = `${baseurl}/update_2fa`
            let request_headers = await this.get_headers(payload)
            const loading = this.$vs.loading()
            axios.post(url,{},request_headers).then(result => {
              console.log(result.data);
              loading.close()
              this.code=''
              if (result.data == 'success') {
                this.dialog = false
                this.desable_2fa_dialog = false
                swal('success', `operation réussie`, "success", {button: "ok"});
                
              }else{
                swal('error', 'erreur veuillez reessayer', "error", {button: "ok"});
              }
              
            }).catch(error => {
              swal({
                                  title: "Erreur",
                                  text: "erreur survenue veuillez reessayer",
                                  icon: "error",
                                })

            })

    },
  }

}
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
  
}
div.referal,div.auth{
  font-family: 'Teko', sans-serif !important;
}
div.v-card.commission {
  border-radius: 20px;
}
p.referal {
  display: block;
  width: 350px;
  height: 40px;
  background-color: rgb(167, 228, 207);
  border-radius: 10px;
  margin: auto;
  font-size: 1.7em;
  padding-left: 10px;
  box-shadow: 5px 5px #888888;
}
div.security {
  display: block;
  width: 90%;
  height: 400px;
  margin: auto;
  background-color: white;
  border-radius: 50px;
}
input.name-input {
  display: inline-block;
  width: 300px;
  border: 1px grey solid;
  height: 50px;
  padding-left: 10px;
  border-radius: 15px;
}
.unit-input {
  display: inline-flex;
  border-radius: 4px;
  overflow: hidden;
  font-family: sans-serif;
}

.unit-input__input {
  border: 1px grey dotted;
  font-size: 1em;
  min-width: 50%;
  font-size: 1.7em;
  border-top-right-radius: 20px;
  box-shadow: 8px 8px #003449, -0.2em 0 0.6em olive;
}

.unit-input__input:focus {
  background: #edfffb;
  outline: none;
}

.unit-input__prepend {
  display: block;
  background: #f4f4f4;
  padding: 0.5em;
  border: #dfdfdf solid 0;
  flex-grow: 0;
  min-width: 70px;
  padding: 20px;
}

.unit-input__prepend {
  border-right-width: 1px;
}

aside.v-navigation-drawer {
  margin-top: 64px !important;
}
h1.profile {
  text-align: center;
}
.achat {
  color: green;
}
.vente {
  color: red;
}
div.container-fluid {
  background-color: #d7dbda;
  height: 100%;
}
.copy {
  cursor: pointer;
}

html {
  box-sizing: border-box;
}

code {
  background-color: #9aa3ac;
  padding: 0 8px;
}

$char-w: 1ch;
$gap: 0.5 * $char-w;
$n-char: 6;
$in-w: $n-char * ($char-w + $gap);

input.code {
  display: inline-block;
  margin-bottom: 1em;
  border: none;
  padding: 0;
  width: $in-w;
  background: repeating-linear-gradient(
      90deg,
      dimgrey 0,
      dimgrey $char-w,
      transparent 0,
      transparent $char-w + $gap
    )
    0 100% / #{$in-w - $gap} 2px no-repeat;
  font: 5ch droid sans mono, consolas, monospace;
  letter-spacing: $gap;

  &:focus {
    outline: none;
    color: dodgerblue;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>